<template>
	<v-flex :class="{'is-fade': loading }">
		<v-card>
			<v-card-text class="pt-4">
				<v-flex xs12 d-flex>
					<v-text-field
						v-model="keyword"
						ref="keyword"
						autofocus
						prepend-icon="search"
						clearable
						label="ค้นหารางวัล"
						type="text"
						:loading="loading"
						@click:prepend="handleSearch"
						@click:clear="handleReset"
						@keypress.enter="handleSearch">
					</v-text-field>
				</v-flex>
				<v-btn class="search-button" color="secondary" @click="handleSearch">SEARCH</v-btn>
        	</v-card-text>
		</v-card>

		<v-card class="search-result mt-3" v-if="items" :flat="!solo">
			<v-card-text>
				<v-list two-line :key="`list-version-${listVersion}`">
					<template v-for="(item, index) in items">
						<v-divider v-if="index > 0"></v-divider>
						<v-list-tile :key="index">
							<v-list-tile-action v-if="action">
								<v-btn icon ripple @click.prevent="action(item)">
									<v-icon v-if="!item.selected" color="grey lighten-1">add</v-icon>
									<v-icon v-else color="red lighten-1">remove_circle_outline</v-icon>
								</v-btn>
							</v-list-tile-action>
							<v-list-tile-content justify-between>
								<!--
								<v-list-tile-title><v-chip v-if="contentType == 'TOPIC'" small :data-type="item.type">{{ item.type }}</v-chip> {{ item.title }}</v-list-tile-title>
								<v-list-tile-sub-title>
									<template v-if="item.user">
										by <a :href="`https://www.jeban.com/mypage/${item.user.id}`" target="_blank" v-html="item.user.username"></a>
									</template>
									<small class="ml-2">{{ item.dateDisplayed }}</small>
								</v-list-tile-sub-title>
								-->
								<v-list-tile-title>{{ item.title }}</v-list-tile-title>
								<v-list-tile-sub-title>
									<span class='text--primary'>{{ item.contentType }}</span> &mdash; {{ item.activityTitle }}
								</v-list-tile-sub-title>
								<v-list-tile-sub-title>
									<small>{{ item.announcedAt ? (new Date(item.announcedAt)).toString().split(' ').slice(1, 3).join(' ') + ', ' + (new Date(item.announcedAt)).getFullYear() : '-' }}</small>
								</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</template>
				</v-list>		
			</v-card-text>
			<v-card-text>
				<div class="text-xs-center" v-if="items.length">
					<v-pagination v-model="currentPage" :length="paginationLength" :total-visible="7" @input="handlePageChanged(currentPage)"></v-pagination>
				</div>
			</v-card-text>
		</v-card>
	</v-flex>	
</template>

<script>
	import * as config from '@/config'

	export default {
		props: {
			value: {
				type: Array,
				default: () => { return [] }
			},
			solo: {
				type: Boolean,
				default: false
			},
			action: {
				type: Function,
				default: () => {}
			},
			selectedPrizes: {
				type: Array,
				default: () => { return [] }
			}
		},
		data () {
			return {
				loading: false,
				isInitted: false,
				keyword: '',
				items: [],
				endList: true,
				currentPage: 1,
				maxPage: 1,
				listVersion: 1
			}
		},
		computed: {
			paginationLength () 
			{
				// return (this.endList) ? this.maxPage : (this.maxPage + 1)
				return this.maxPage + 1
			}
		},
		methods: {
			handleReset ()
			{
				this.keyword = ''
				if (!this.action) {
					this.handleSearch()
				} else {
					this.items = []
					this.currentPage = 1
					this.maxPage = 1
					this.endList = true
				}
			},
			handleSearch ()
			{
				this.currentPage = 1
				this.maxPage = 1
				this.endList = true

				this.handlePageChanged(this.currentPage)
			},
			handlePageChanged (page)
			{
				const params = new URLSearchParams()

				let url = `${config.BASE_URL}/luckylist/prize/announced?limit=10&page=${page}`

				params.append('keyword', this.keyword)

				this.currentPage = page
				this.loading = true

				axios.get(url, { params: params})
					.then((response) => {
						this.items = []
						if (response.data.data && response.data.data.length > 0) {
							this.items = response.data.data

							this.items = []
							response.data.data.forEach(item => {
								item.selected = (this.selectedPrizes.filter(z => z.id == item.id).length) ? true : false

								this.items.push(item)
							})

							if (response.data.data.length < response.data.perPage) {
								this.endList = true
							} else {
								this.endList = false
								this.maxPage = (this.currentPage > this.maxPage) ? this.currentPage : this.maxPage
							}
						} else {
							this.items = []
						}
						this.loading = false
					})				
			},
			initComponent () 
			{
                if (this.isInitted) return
                
                setTimeout(() => {
	                // console.log(this.value)
                }, 2000)

            	this.isInitted = true
            	this.items = this.value            	
			}
		},
		mounted () {
			if (this.solo) {
				this.handlePageChanged(1)
			} else {
				this.$nextTick(this.initComponent)
			}
		},
		watch: {
            value (newValue) {
                if (!this.isInitted) {
                    this.initComponent()
                }
            },
            selectedPrizes: {
            	handler (value) {
					this.items.forEach((item, index) => {
						this.items[index].selected = (value.filter(z => z.id == item.id).length) ? true : false
					})
					this.listVersion++
            	},
            	deep: true
            }
		}
	}
</script>

<style lang="scss">
	.search-result {
		div[role="listitem"] {
			overflow: hidden;
		}
		.v-list__tile__content {
			display: flex;
			justify-content: space-around;

			a {
				color: #718daa;
				text-decoration: none;
			}
		}
		.v-list__tile__title {
			display: flex;
			align-items: center;
		}
		.v-chip {
			height: 20px;

			span {
				height: 20px;
				font-size: 12px;
			}

			&[data-type="HOWTO"] {
				background-color: #f9c93c;
				color: white;
			}
			&[data-type="REVIEW"] {
				background-color: #f6b699;
				color: white;
			}
			&[data-type="QA"] {
				background-color: #a7c1ec;
				color: white;
			}
			&[data-type="HAUL"] {
				background-color: #a1e4d3;
				color: white;
			}
			&[data-type="STORY"] {
				background-color: #d4afeb;
				color: white;
			}
		}
		img.d-block {
			display: block;
		}
	}
</style>